/* Publish by EComposer at 2026-09-29 23:22:13*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-9h2mjuodbps"]=  window.__ectimmers["ecom-9h2mjuodbps"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-9h2mjuodbps').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9h2mjuodbps', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yt7mx2568i7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yt7mx2568i7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3hi9dtf49r2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3hi9dtf49r2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ky41p4sr82s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ky41p4sr82s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-01x4r5et2c67').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-01x4r5et2c67', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-22i0sy2nvo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-22i0sy2nvo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u9aix26jhve').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u9aix26jhve', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lw88hcx8n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lw88hcx8n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9hmep0aa02').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9hmep0aa02', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-14bbivx3ggeb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-14bbivx3ggeb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bf32jegzev').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bf32jegzev', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2o2xtvb6owz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2o2xtvb6owz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ezmytkm7146').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ezmytkm7146', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j2l3p8os53').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j2l3p8os53', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ka6zoft54d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ka6zoft54d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y2rxh8be33b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y2rxh8be33b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c5urj941xg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c5urj941xg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rfpzst35gf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rfpzst35gf', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-mqczlfl2kih"]=  window.__ectimmers["ecom-mqczlfl2kih"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(o){const s=o.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-o.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let o=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");o&&(i(o)?(o.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(o.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-mqczlfl2kih').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mqczlfl2kih', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h0grv668rkk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h0grv668rkk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xk4i1pthm3f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xk4i1pthm3f', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t0am4cnvyy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t0am4cnvyy', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2cbgo4715x2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2cbgo4715x2', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2uj6ykgxkpw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2uj6ykgxkpw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-95risfv55he').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-95risfv55he', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4xdjxm0hekm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4xdjxm0hekm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s47oswyly6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s47oswyly6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p6rw3cqe8ta').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p6rw3cqe8ta', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zqqmdw4ysc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zqqmdw4ysc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n6oaomcyntg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n6oaomcyntg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pp94nrj81e8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pp94nrj81e8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wxicdnhw3va').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wxicdnhw3va', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5b7m9ymbnt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5b7m9ymbnt', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2xjwes531ov"]=  window.__ectimmers["ecom-2xjwes531ov"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const n=t.querySelector(".ecom__element--button");if(!n)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-2xjwes531ov"]["oninenbzo"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},s)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let n=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},n);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-2xjwes531ov').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2xjwes531ov', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vybj794wuvb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vybj794wuvb', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ztjb8gfjxa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ztjb8gfjxa', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1cb1t939ln2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1cb1t939ln2', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}